import { render } from "./MovimientosBanco.vue?vue&type=template&id=6dc71273&scoped=true"
import script from "./MovimientosBanco.vue?vue&type=script&lang=js"
export * from "./MovimientosBanco.vue?vue&type=script&lang=js"

import "./MovimientosBanco.vue?vue&type=style&index=0&id=6dc71273&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc71273"]])

export default __exports__